<template>
  <of-dialog :title="formTitle" @onCancel="cancel" :width="width" :appendToBody="true">
    <div slot="content">
      <el-form ref="form" label-width="150px" :model="dataFormProg">
        <el-form-item label="标题：">
          {{ dataFormProg.Title }}
        </el-form-item>
        <el-form-item label="进展描述：">
          {{ dataFormProg.Describe }}
        </el-form-item>
        <el-form-item label="进展时间：">
          {{ dataFormProg.ActivityTime | formatDate2 }}
        </el-form-item>
        <el-form-item label="图片：">
          <el-upload
            class="upload-demo"
            action="/api/File/FileUpload"
            :on-preview="onPicPreview"
            :file-list="pictureList"
          >
          </el-upload>
          <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
            <img
              style="width: 80%; height: 70%; margin-left: 10%"
              :src="dialogImageUrl"
              alt
            />
          </el-dialog>
        </el-form-item>
        <el-form-item label="附件：">
          <el-upload
            class="upload-demo"
            action="/api/File/FileUpload"
            :on-preview="onFilePreview"
            :file-list="fileList"
          >
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>

<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfUpload from "@/components/controls/of_upload/of_upload";
import api from "@/modules/zjrc/api";

export default {
  name: "progressquery",
  props: {
    dataFormProg: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      width: "50%",
      formTitle: "查看详情",
      dialogImageUrl: "",
      dialogVisible: false,
      pictureList: [],
      hidePic: false,
      fileList: [], //附件数组
    };
  },
  components: {
    OfDialog,
    OfUpload,
  },
  mounted() {
    let that = this;
    that.getImg();
    that.getlistfile();
  },
  methods: {
    cancel() {
      this.$emit("formCallBack", null);
    },
    //图片初始化
    getImg() {
      let that = this;
      if (
        that.dataFormProg.ActivityImage ||
        that.dataFormProg.ActivityImage != null
      ) {
        let params = { Id: that.dataFormProg.ActivityImage };
        api.QueryBigSickApplyFileByIds(params).then((res) => {
          if (res.data.Code == 0) {
            let fileList = res.data.Data;
            fileList.forEach((item) => {
              that.pictureList.push({
                url: item.Url,
                name: item.FileName,
              });
            });
          }
        });
      }
    },
    //图片查看
    onPicPreview(file) {
      let that = this;
      that.dialogImageUrl = file.url;
      that.dialogVisible = true;
    },
    //加载文件
    getlistfile() {
      let that = this;
      if (that.dataFormProg.File || that.dataFormProg.File != null) {
        let params = { Id: that.dataFormProg.File };
        api.QueryBigSickApplyFileByIds(params).then((res) => {
          if (res.data.Code == 0) {
            let fileList = res.data.Data;
            fileList.forEach((item) => {
              that.fileList.push({
                url: item.Url,
                name: item.FileName,
              });
            });
          }
        });
      }
    },
    //附件下载
    onFilePreview(file) {
      saveAs(file.url, file.name);
    },
  },
};
</script>

<style scoped>
.of-dialog >>> .el-button--primary {
  display: none;
}

.of-dialog >>> .el-button--default {
  display: none;
}

.upload-demo >>> .el-icon-close {
  display: none !important;
}
.pload-demo >>> .el-icon-close-tip {
  display: none !important;
}
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}
.upload-demo >>> .el-upload--text {
  display: none !important;
}
</style>
